/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EdrApiKey } from './edrApiKey';


export interface EdrApiKeyEntry { 
    api_key: EdrApiKey;
}

